export const NAME = "orders/list" as const;
